import { Component, OnInit } from '@angular/core';

type EspecialidadesDescuentosTab =
  | 'especialidades'
  | 'descuentos';

@Component({
  selector: 'app-especialidades-y-descuentos',
  templateUrl: './especialidades-y-descuentos.component.html',
  styleUrls: ['./especialidades-y-descuentos.component.css']
})
export class EspecialidadesYDescuentosComponent implements OnInit {

  public activeTab: EspecialidadesDescuentosTab =
    'especialidades';

  public cantidadEspecialidades = 0;
public cantidadDescuentos = 0;

public onCantidadDescuentosChange(
  cantidad: number
): void {

  this.cantidadDescuentos = cantidad;
}
  constructor() { }

  ngOnInit(): void {
  }

  public setActiveTab(
    tab: EspecialidadesDescuentosTab
  ): void {

    this.activeTab = tab;
  }

  public onCantidadEspecialidadesChange(
    cantidad: number
  ): void {

    this.cantidadEspecialidades = cantidad;
  }

}